import React from 'react';
import createReactClass from 'create-react-class';
import Widget from './Widget';
import Actionbar from './Actionbar';
import auth0 from '../../helpers/auth0';

var SimplePage = createReactClass({
  getDefaultProps() {
    return {
      title: 'No title provided!',
      actions: [],
      reports: [],
      icon: 'cube'
    };
  },

  render() {
    let { actions, reports, title, icon, children} = this.props;

    let allowedActions = actions.filter(action => !action.claim || auth0.hasClaim(action.claim));
    let allowedReports = reports.filter(report => !report.claim || auth0.hasClaim(report.claim));

    let showActionbar = allowedActions.length > 0 || allowedReports.length > 0;
    let width = showActionbar ? 'col-md-10' : 'col-md-12';

    return (
      <div className="row">
        <Widget title={title} containerClassName={width} icon={icon}>
          {children}
        </Widget>
        { showActionbar ? (<Actionbar actions={allowedActions} reports={allowedReports}/>) : null }
      </div>
    );
  }
});

export default SimplePage;



// WEBPACK FOOTER //
// ./src/components/common/SimplePage.js